export { PushNotificationCoordinator } from "./service/push-notification-coordinator";
export * from "./types";

// Export singleton instance for easy consumption
import { PushNotificationCoordinator } from "./service/push-notification-coordinator";
export const pushNotificationService = new PushNotificationCoordinator();
export default pushNotificationService;
